$(document).ready(function() {
  $(".qn-partner-news-box").each(function(){
    //console.debug("initLocalmente");
    var qnlocal_news = $(".qn-partner-news", $(this));
    var qnlocal_pages = Math.floor(qnlocal_news.length);
    var qnlocal_ppp = Math.ceil(qnlocal_news.length / qnlocal_pages);
    var slider_nav = $('.nav', $(this));
    if (qnlocal_pages <= 1) {
        $(slider_nav).hide();
        return;
    }
    var qnlocal_divs = [];
    var card_owner;
    for (var i = 0; i < qnlocal_news.length; i++) {
        card_owner = qnlocal_news[i].getElementsByClassName("card-owner__name");
        if (card_owner && card_owner.length) {
            // strips unwanted tails from site titles
            card_owner[0].innerText = card_owner[0].innerText.split(/ \W /)[0];
        }
        qnlocal_divs.push(qnlocal_news[i]);
    }
    var shuffle = function(list) {
        return list.sort(function(){return .5 - Math.random()});
    }
    qnlocal_divs = shuffle(qnlocal_divs);
    for (var x = 0; x < qnlocal_pages; x++) {
        var slide = document.createElement("div");
        slide.className = "qn-partner-news-slide";
        this.appendChild(slide);
        for (var y = 0; y < qnlocal_ppp; y++) {
            var z = qnlocal_ppp * x + y;
            if (qnlocal_divs[z]) {
                slide.appendChild(qnlocal_divs[z]);
            }
        }
    }
    $(this).slick({
        appendArrows: slider_nav,
        prevArrow: '<div class="arrow-left"><svg class="svg" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M8 16c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.742-9.42H8V4.295c0-.346-.42-.52-.661-.275L3.652 7.726a.384.384 0 0 0 0 .545l3.687 3.706A.387.387 0 0 0 8 11.703V9.42h3.742a.388.388 0 0 0 .387-.387V6.968a.388.388 0 0 0-.387-.387z" fill="#000" fill-rule="nonzero" fill-opacity=".2"></path></svg></div>',
        nextArrow: '<div class="arrow-right"><svg class="svg" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M8 16c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.742-9.42H8V4.295c0-.346-.42-.52-.661-.275L3.652 7.726a.384.384 0 0 0 0 .545l3.687 3.706A.387.387 0 0 0 8 11.703V9.42h3.742a.388.388 0 0 0 .387-.387V6.968a.388.388 0 0 0-.387-.387z" fill="#000" fill-rule="nonzero" fill-opacity=".2"></path></svg></div>',
        draggable: false,
        initialSlide: 0,
        vertical: true,
        slide: '.' + slide.className,
        slidesToShow: 5,
        slidesToScroll: 1,
        verticalSwiping: true,
        variableWidth: false,
        autoplay: true,
    });
  });
}); // end document ready
